export default "/images/vendor/@coreui/icons/svg/flag/cif-nl.svg?c9fd8ac0af856cd10b954815a1c55a94";